module.exports = __webpack_public_path__ + "static/media/apex-logo-reverse.e9c20128.svg";